import { resolver } from "@msuite/ui/libs/form";
import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import { invalidate, useQueryClient } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { type CostCenterSchema, costCenterSchema } from "@msuite/utils/schemas";
import { FormProvider, useForm } from "react-hook-form";
import { CostCenterForm } from "@/forms/cost-center-form";
import { client } from "@/hono";

export function AddCostCenterModal({ isOpen, onClose }: ModalProps) {
	/** Hooks */
	const { t } = useTranslation();
	const qc = useQueryClient();
	const methods = useForm<CostCenterSchema>({
		defaultValues: { number: "", name: "", color: "gray", isActive: true },
		resolver: resolver(costCenterSchema),
	});

	/** Functions */
	async function handleOnSubmit(json: CostCenterSchema) {
		const response = await client.cost_centers.index.$post({ json });
		await responseHandler(response);
		await qc.invalidateQueries({ predicate: invalidate(["cost-centers"]) });
		onClose();
	}

	/** Render */
	return (
		<FormProvider {...methods}>
			<Modal
				isOpen={isOpen}
				onClose={onClose}
				title={t("cost_centers.add_cost_center")}
				onSubmit={methods.handleSubmit(handleOnSubmit)}
				isLoading={methods.formState.isLoading}
			>
				<Modal.Body>
					<CostCenterForm />
				</Modal.Body>
				<Modal.FooterForm />
			</Modal>
		</FormProvider>
	);
}
